export default "__VITE_ASSET__D0$1UlOk__"